(function () {
  'use strict';
  if (window.__eliteGiftBundleLoaded) return;
  window.__eliteGiftBundleLoaded = true;
  var root = window.Shopify && window.Shopify.routes.root || '/';
  var widget, form, quick, config, mode = null, modeKey = '', selected = null, busy = false,checkoutPending=false, cleaning = false, exitAttempted = false;
  var giftDuration = 60 * 1000, giftDeadline = 0, giftTimer = null, giftInView = false, giftStorageKey='elite-gift-deadline:v6-store';
  var giftDeadlineMemory = Object.create(null);
  var recoveryDialog, recoveryForm, recoveryUsed = false, recoveryUsedKey = '', recoveryPendingKey = '', recoveryFocus = null, recoveryProtected = false;

  function giftExpired() {
    return mode === 'gift' && giftDeadline > 0 && Date.now() >= giftDeadline;
  }

  function stopGiftTimer() {
    if (giftTimer !== null) window.clearInterval(giftTimer);
    giftTimer = null;
  }

  function readGiftDeadline() {
    var current = Number(recoveryValue(giftStorageKey));
    if (Number.isFinite(current) && current > 0) return current;
    var earliest = 0;
    // Carry an existing expiry forward; changing products or remounting cannot restart it.
    [function () { return window.sessionStorage; }, function () { return window.localStorage; }].forEach(function (getStorage) {
      try { var storage = getStorage(); for (var i = 0; i < storage.length; i++) {
        var key = storage.key(i);
        if (key && key.indexOf('elite-gift-deadline:v5-1m:') === 0) {
          var value = Number(storage.getItem(key));
          if (Number.isFinite(value) && value > 0 && (!earliest || value < earliest)) earliest = value;
        }
      } } catch (error) {}
    });
    if (earliest) saveRecoveryValue(giftStorageKey, String(earliest));
    return earliest;
  }

  function saveGiftDeadline() { saveRecoveryValue(giftStorageKey, String(giftDeadline)); }

  function syncGiftCountdown() {
    var savedDeadline = readGiftDeadline();
    if (savedDeadline > 0) giftDeadline = savedDeadline;
    if (recoveryUsedKey && recoveryValue(recoveryUsedKey) === '1') recoveryUsed = true;

    if (!widget) return;
    var countdown = widget.querySelector('[data-gift-countdown]');
    if (!countdown) return;
    countdown.hidden = mode !== 'gift';
    var fieldset = widget.querySelector('.eg-options');
    var panel = widget.querySelector('[data-gift-panel]');
    if (mode === 'gift' && !giftDeadline && giftInView && !document.hidden && !widget.hidden && !panel.hidden) {
      giftDeadline = Date.now() + giftDuration;
      saveGiftDeadline();
    }
    var remaining = giftDeadline ? Math.max(0, giftDeadline - Date.now()) : giftDuration;
    var seconds = Math.ceil(remaining / 1000);
    var value = countdown.querySelector('[data-gift-countdown-value]');
    if (value) value.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    var ring = countdown.querySelector('[data-gift-countdown-ring]');
    if (ring) ring.style.setProperty('--eg-countdown-angle', Math.min(360, remaining / giftDuration * 360) + 'deg');
    var expired = giftExpired();
    widget.dataset.giftCountdownState = expired ? 'expired' : giftDeadline ? 'running' : 'ready';
    if (fieldset) fieldset.disabled = expired || busy;
    if (expired) selection();
    syncGiftRecovery();
    if (mode === 'gift' && giftDeadline && !expired && !document.hidden) {
      if (giftTimer === null) giftTimer = window.setInterval(syncGiftCountdown, 1000);
    } else stopGiftTimer();
  }

  function mountGiftCountdown() {
    if (!widget.querySelector('[data-gift-countdown]')) return;
    giftStorageKey = 'elite-gift-deadline:v6-store';
    giftDeadline = readGiftDeadline();
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.target === widget) giftInView = entry.isIntersecting && entry.intersectionRatio > 0; });
        syncGiftCountdown();
      }, { threshold: 0 });
      observer.observe(widget);
    } else {
      var checkVisibility = function () {
        var rect = widget.getBoundingClientRect();
        giftInView = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        syncGiftCountdown();
      };
      window.addEventListener('scroll', checkVisibility, { passive: true });
      window.addEventListener('resize', checkVisibility);
      window.setTimeout(checkVisibility, 0);
    }
    document.addEventListener('visibilitychange', syncGiftCountdown);
    window.addEventListener('pageshow', syncGiftCountdown);
  }

  function recoveryValue(key) {
    // Persistent storage is authoritative; stale per-tab session values must not replace it.
    var value = null;
    try { value = window.localStorage.getItem(key); } catch(error) {}
    if (value !== null) return value;
    try {
      var prefix = encodeURIComponent(key) + '=';
      var cookie = document.cookie.split(';').map(function(part) { return part.trim(); }).find(function(part) { return part.indexOf(prefix) === 0; });
      if (cookie) return decodeURIComponent(cookie.slice(prefix.length));
    } catch(error) {}
    try { value = window.sessionStorage.getItem(key); } catch(error) {}
    return value || giftDeadlineMemory[key] || null;
  }

  function saveRecoveryValue(key, value) {
    giftDeadlineMemory[key] = value;
    var saved = false;
    try { window.localStorage.setItem(key,value); saved = window.localStorage.getItem(key) === value; } catch(error) {}
    try { document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; } catch(error) {}
    try { window.sessionStorage.setItem(key,value); saved = window.sessionStorage.getItem(key) === value || saved; } catch(error) {}
    return saved;
  }

  function clearRecoveryValue(key) {
    delete giftDeadlineMemory[key];
    try { window.localStorage.removeItem(key); } catch (error) {}
    try { window.sessionStorage.removeItem(key); } catch (error) {}
  }

  function syncGiftRecovery() {
    if (!widget) return;
    var expired = giftExpired();
    var trigger = widget.querySelector('[data-gift-expired-trigger]');
    var open = widget.querySelector('[data-gift-recovery-open]');
    var final = widget.querySelector('[data-gift-recovery-final]');
    var success = widget.querySelector('[data-gift-recovery-success]');
    if (trigger) { trigger.hidden = !expired || recoveryUsed; trigger.disabled = busy || recoveryUsed; }
    if (open) { open.hidden = !expired || recoveryUsed; open.disabled = busy || recoveryUsed; }
    if (final) final.hidden = !expired || !recoveryUsed;
    if (success) success.hidden = mode !== 'gift' || !recoveryUsed || !giftDeadline || expired;
  }

  

  function openGiftRecovery(trigger) {
    if (!recoveryDialog || busy || !giftExpired() || recoveryUsed) return;
    var cart = document.getElementById('mini-cart');
    if (cart && widget.dataset.cartGift === 'true' && cart.getAttribute('aria-hidden') !== 'false') {
      var toggle = document.querySelector('.header__cart-toggle'); if (toggle) toggle.click();
    }
    if (cart && cart.getAttribute('aria-hidden') === 'false' && !cart.contains(recoveryDialog)) cart.appendChild(recoveryDialog);
    recoveryFocus = trigger || document.activeElement;
    recoveryDialog.querySelectorAll('[data-gift-recovery-yes], [data-gift-recovery-no]').forEach(function (input) { input.checked = false; });
    if (!recoveryDialog.open) recoveryDialog.showModal();
    var yes = recoveryDialog.querySelector('[data-gift-recovery-yes]'); if (yes) yes.focus();
  }

  function closeGiftRecovery() {
    if (recoveryDialog && recoveryDialog.open) recoveryDialog.close();
  }

  

    var recoveryFrame = null, recoveryWaiting = false;

  

  function completeGiftRecovery() {
    if (recoveryValue(recoveryUsedKey) === '1') { recoveryUsed = true; syncGiftCountdown(); closeGiftRecovery(); return; }
    if (!widget || busy || recoveryUsed || !giftExpired()) return;
    recoveryUsed = true;
    saveRecoveryValue(recoveryUsedKey, '1');
    giftDeadline = Date.now() + giftDuration;
    saveGiftDeadline();
    modeKey = '';
    var panel = widget.querySelector('[data-gift-panel]');
    var reopen = widget.querySelector('[data-reopen-gifts]');
    if (panel) panel.hidden = false;
    if (reopen) reopen.hidden = true;
    syncMode();
    closeGiftRecovery();
  }

  

  function normalizeCartGiftChoices() {
    if (!widget) return;
    widget.querySelectorAll('[data-gift-choice]').forEach(function (choice) {
      choice.querySelectorAll('a').forEach(function (link) {
        var label = document.createElement('span');
        label.className = link.className;
        while (link.firstChild) label.appendChild(link.firstChild);
        link.replaceWith(label);
      });
      choice.querySelectorAll('[data-gift-variant-wrap]').forEach(function (wrap) { wrap.hidden = true; });
      choice.querySelectorAll('[data-gift-variant]').forEach(function (select) {
        var option = Array.from(select.options).find(function (item) { return !item.disabled; });
        if (option) {
          select.value = option.value;
          choice.querySelector('input[name="elite_free_gift"]').value = option.value;
        }
        select.hidden = true;
        select.disabled = true;
      });
      updateChoicePrice(choice);
      updateVariantMedia(choice);
    });
    var visible = Array.from(widget.querySelectorAll('[data-gift-choice]')).filter(function (choice) { return !choice.hidden; });
    visible.forEach(function (choice, index) {
      if (index < 2) return;
      choice.hidden = true;
      var radio = choice.querySelector('input[name="elite_free_gift"]');
      radio.checked = false; radio.disabled = true;
    });
  }

  function collapseCartGiftChoices() {
    if (!widget) return;
    var panel = widget.querySelector('[data-gift-panel]');
    var reopen = widget.querySelector('[data-reopen-gifts]');
    if (panel) panel.hidden = true;
    if (reopen) reopen.hidden = false;
    syncGiftCountdown();
  }

  function mountGiftRecovery() {
    if (!widget) return;
    recoveryUsedKey = 'elite-gift-recovery-used:v2-store';
    recoveryUsed = recoveryValue(recoveryUsedKey) === '1';
    var template = offerDocument && offerDocument.getElementById('EliteGiftRecoveryTemplate');
    if (!template) return;
    document.body.appendChild(template.content.cloneNode(true));
    recoveryDialog = document.getElementById('EliteGiftRecoveryDialog');
    if (!recoveryDialog) return;
    widget.querySelectorAll('[data-gift-expired-trigger], [data-gift-recovery-open]').forEach(function(trigger) {
      trigger.addEventListener('click',function(event) { event.preventDefault(); event.stopPropagation(); openGiftRecovery(trigger); });
    });
    recoveryDialog.addEventListener('keydown',function(event) { event.stopPropagation(); });
    var yes=recoveryDialog.querySelector('[data-gift-recovery-yes]');
    var no=recoveryDialog.querySelector('[data-gift-recovery-no]');
    if (yes) yes.addEventListener('change',function() { if(yes.checked) completeGiftRecovery(); });
    if (no) no.addEventListener('change',function() { if(no.checked) closeGiftRecovery(); });
    recoveryDialog.querySelectorAll('[data-gift-recovery-close]').forEach(function(button) { button.addEventListener('click',closeGiftRecovery); });
    recoveryDialog.addEventListener('close',function() { if(recoveryFocus && recoveryFocus.isConnected && typeof recoveryFocus.focus === 'function') recoveryFocus.focus(); });
    syncGiftRecovery();
  }

  async function request(path, data) {
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (data) {
      options.method = 'POST';
      options.headers = { 'Content-Type': 'application/json' };
      options.body = JSON.stringify(data);
    }
    var response = await fetch(root + path, options);
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Inténtalo de nuevo. Tu pedido no se ha completado.');
    return result;
  }

  function message(text) {
    var error = widget && widget.querySelector('[data-gift-error]');
    if (error) { error.textContent = text || ''; error.hidden = !text; }
  }

  function mainVariant() { return activeCartLine ? { id: activeCartLine.variant_id, price: activeCartLine.original_price } : null; }

  function updateChoicePrice(choice) {
    var variant = choice.querySelector('[data-gift-variant]');
    var option = variant && variant.selectedOptions[0];
    if (option) {
      choice.dataset.priceCents = option.dataset.priceCents;
      choice.dataset.halfPrice = option.dataset.halfPrice;
      choice.querySelector('[data-gift-was]').textContent = option.dataset.price;
    }
    var now = choice.querySelector('[data-gift-now]');
    now.textContent = mode === 'gift' ? now.dataset.zero : choice.dataset.halfPrice;
    choice.dataset.code = mode === 'gift' ? choice.dataset.giftCode : choice.dataset.addonCode;
  }

  function syncMode() {
    if (!widget || !config) return;
    var variant = mainVariant();
    var next = variant && variant.price > 0 ? variant.price >= 4000 ? 'gift' : 'addon' : null;
    var key = next + ':' + (variant && variant.price);
    if (key === modeKey) { syncGiftCountdown(); return; }
    modeKey = key;
    mode = next;
    widget.hidden = !mode;
    widget.dataset.offerMode = mode || '';
    var choices = Array.from(widget.querySelectorAll('[data-gift-choice]'));
    var primaryIsChoice = choices.some(function (choice) { return !choice.hasAttribute('data-replacement') && choice.dataset.productId === widget.dataset.productId; });
    choices.forEach(function (choice) {
      var replacement = choice.hasAttribute('data-replacement');
      choice.hidden = !mode || (mode === 'gift' ? replacement : choice.dataset.productId === widget.dataset.productId || replacement && !primaryIsChoice);
      var radio = choice.querySelector('input[name="elite_free_gift"]');
      radio.disabled = choice.hidden;
      radio.checked = false;
      updateChoicePrice(choice);
    });
    if (mode) {
      var copy = config.copy[mode];
      widget.setAttribute('aria-label', copy.title);
      widget.querySelector('[data-offer-title]').textContent = copy.title;
      widget.querySelector('[data-offer-intro]').textContent = copy.intro;
      widget.querySelector('[data-offer-terms]').textContent = copy.terms;
      widget.querySelector('[data-close-gifts]').setAttribute('aria-label', copy.close);
      widget.querySelector('[data-reopen-gifts]').textContent = copy.title;
      widget.querySelectorAll('[data-offer-badge]').forEach(function (badge) { badge.textContent = copy.badge; });
      widget.querySelectorAll('.eg-price svg').forEach(function (icon) { icon.toggleAttribute('hidden', mode !== 'gift'); });
      widget.querySelectorAll('[data-offer-variant-label]').forEach(function (label) { label.textContent = copy.variant; });
      var status = widget.querySelector('[data-gift-status]');
      status.dataset.empty = copy.empty;
      status.dataset.selected = copy.selected;
      var fieldset = widget.querySelector('.eg-options');
      choices.sort(function (a, b) {
        if (mode === 'gift') return Number(a.hasAttribute('data-replacement')) - Number(b.hasAttribute('data-replacement'));
        var first = Number(a.dataset.priceCents), second = Number(b.dataset.priceCents);
        return Math.abs(first - variant.price) - Math.abs(second - variant.price) || first - second;
      }).forEach(function (choice) { fieldset.appendChild(choice); });
    }
    normalizeCartGiftChoices(),syncGiftCountdown(),selection();
  }

  function updateVariantMedia(choice) {
    var variant = choice.querySelector('[data-gift-variant]');
    var option = variant && variant.selectedOptions[0];
    if (!option) return;
    var picture = choice.querySelector('img.eg-picture');
    if (picture && option.dataset.image) {
      picture.removeAttribute('srcset');
      picture.removeAttribute('sizes');
      picture.src = option.dataset.image;
      if (option.dataset.imageAlt) {
        picture.alt = option.dataset.imageAlt;
        picture.title = option.dataset.imageAlt;
      }
    }
    choice.querySelectorAll('a[data-gift-link]').forEach(function (link) {
      var url = new URL(link.href, location.href);
      url.searchParams.set('variant', variant.value);
      link.href = url.href;
    });
  }

  function selection() {
    var expired = giftExpired();
    if (expired) {
      widget.querySelectorAll('input[name="elite_free_gift"]').forEach(function (input) { input.checked = false; input.disabled = true; });
      var fieldset = widget.querySelector('.eg-options');
      if (fieldset) fieldset.disabled = true;
    }
    var radio = widget.querySelector('input[name="elite_free_gift"]:checked');
    selected = radio && !radio.disabled ? radio.closest('[data-gift-choice]') : null;
    widget.querySelectorAll('[data-gift-variant-wrap]').forEach(function (wrap) {
      wrap.hidden = true;
    });
    var status = widget.querySelector('[data-gift-status]');
    status.textContent = expired ? config.copy.gift.countdown_expired : selected ? status.dataset.selected : status.dataset.empty;
    form.classList.toggle('elite-gift-active', !!selected || busy);
    if (quick) quick.hidden = !selected;
    if (cartGiftButton) cartGiftButton.disabled = !selected || busy || expired;
    syncGiftRecovery();
    message('');
  }

  function clearSelection() {
    widget.querySelectorAll('input[name="elite_free_gift"]').forEach(function (input) { input.checked = false; });
    selection();
  }

  function exitOffer(reason, destination) {
    if (busy || giftExpired()) return false;
    var detail = { reason: reason, destination: destination || null, handled: false };
    document.dispatchEvent(new CustomEvent('elite:gift-exit', { detail: detail }));
    return detail.handled;
  }

  function mainItem(transaction) { return activeCartLine ? { id: activeCartLine.variant_id, quantity: 0, properties: {} } : null; }

  function ownedOffer(item) {
    var properties = item.properties;
    if (properties && properties._elite_extra_titanium === '50-percent-off' && properties._EliteUpgrade) return false;
    return properties && (properties._EliteGift === '1' || properties._EliteAddon === '1');
  }

  async function removeOfferLines(cart) {
    var updates = {};
    cart.items.forEach(function (item) {
      if (ownedOffer(item)) updates[item.key] = 0;
    });
    if (Object.keys(updates).length) return request('cart/update.js', { updates: updates });
    return cart;
  }

  async function rollback(transaction, previous, removed) {
    try {
      var cart = await request('cart.js');
      var updates = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._EliteBundle === transaction) updates[item.key] = 0;
      });
      if (Object.keys(updates).length) await request('cart/update.js', { updates: updates });
      if (removed) {
        var offers = previous.items.filter(ownedOffer).map(function (item) {
          return { id: item.variant_id, quantity: item.quantity, properties: item.properties };
        });
        if (offers.length) await request('cart/add.js', { items: offers });
      }
      if (previous && window.EliteCartPromotions) await window.EliteCartPromotions.applyCodes((previous.discount_codes || []).map(function (entry) { return entry.code; }));
    } catch (error) { message('Revisa tu carrito antes de intentarlo de nuevo.'); }
  }

  function cartGiftCheckoutForm(element){var candidate=element&&(element.tagName==="FORM"?element:element.form||element.closest&&element.closest("form"));if(!candidate)return null;try{var action=new URL(candidate.action,window.location.origin);return action.origin===window.location.origin&&/\/cart\/?$/.test(action.pathname)?candidate:null}catch{return null}}function nativeCartGiftCheckout(candidate){if(!candidate){window.location.assign(root+"checkout");return}if(!candidate.reportValidity())return;var marker=document.createElement("input");marker.type="hidden",marker.name="checkout",marker.value="checkout",candidate.appendChild(marker);try{window.HTMLFormElement.prototype.submit.call(candidate)}finally{marker.remove()}}async function openCartGiftCheckout(element){var candidate=cartGiftCheckoutForm(element);if(candidate&&!candidate.reportValidity())return;checkoutPending=!0;try{if(window.EliteCheckoutEmail&&typeof window.EliteCheckoutEmail.checkout==="function")await window.EliteCheckoutEmail.checkout(root+"checkout",candidate);else nativeCartGiftCheckout(candidate)}catch{try{nativeCartGiftCheckout(candidate)}catch{}}finally{checkoutPending=!1}}async function purchase(toCheckout, discountOnly, trigger) {if(window.EliteSitewide25&&window.EliteSitewide25.isActive())return;
    if (checkoutPending||(busy || !form)) return;
    var transaction = 'elite-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
    var added = false, previous = null, removed = false;
    var buttons = Array.from(form.querySelectorAll('button[type="submit"], [data-gift-quick]'));
    var originalText = trigger && trigger.textContent;
    try {
      syncMode();
      if (!discountOnly && giftExpired()) { selection(); return; }
      var main = mainItem(transaction);
      if (!main) return;
      var choice = discountOnly ? null : selected;
      if (!choice && !discountOnly) return;
      if (choice && (choice.hidden || choice.dataset.productId === widget.dataset.productId)) throw new Error('Elige un artículo adicional diferente.');
      var purchaseMode = mode;
      var expected = choice && (purchaseMode === 'gift' ? 0 : Math.ceil(Number(choice.dataset.priceCents) / 2));
      var variant = choice && choice.querySelector('[data-gift-variant]');
      var variantId = choice && Number(variant ? variant.value : choice.querySelector('input').value);
      var selectedCode = choice && choice.dataset.code;
      busy = true;
      syncGiftCountdown();
      widget.setAttribute('aria-busy', 'true');
      message('');
      buttons.forEach(function (button) { button.dataset.eliteWasDisabled = String(button.disabled); button.disabled = true; });
      if (trigger && !form.contains(trigger)) { trigger.disabled = true; trigger.textContent = 'Agregando al carrito…'; }
      previous = await request('cart.js');
      if (!previous.items.some(function (item) { return activeCartLine && item.key === activeCartLine.key && !ownedOffer(item); })) throw new Error('Tu carrito ha cambiado. Vuelve a elegir tu oferta.');
      await removeOfferLines(previous);
      removed = previous.items.some(ownedOffer);
      // A returning shopper may already have this product in the cart (e.g. from an
      // earlier gift purchase or an abandoned checkout). Only add what is missing so
      // BUY NOW swaps the gift instead of creating a second line of the same product.
      var inCart = previous.items.reduce(function (total, item) {
        return item.variant_id === main.id && !ownedOffer(item) ? total + item.quantity : total;
      }, 0);
      main.quantity -= Math.min(inCart, main.quantity);
      var items = main.quantity > 0 ? [main] : [];
      var code = discountOnly;
      if (choice) {
        var properties = { _EliteBundle: transaction };
        if (purchaseMode === 'gift') properties._EliteGift = '1';
        else {
          properties._EliteAddon = '1';
          properties._EliteAddonCode = selectedCode;
        }
        items.push({ id: variantId, quantity: 1, properties: properties });
        code = selectedCode;
      }
      if (items.length) {
        added = true;
        await request('cart/add.js', { items: items });
      }
      var current = await request('cart.js');
      var codes = (current.discount_codes || []).map(function (entry) { return entry.code; }).filter(function (existing) {
        var upper = existing.toUpperCase();
        return upper !== 'TITANIUM15' && upper !== 'TITANIUM10' && upper !== 'ELITE-TITANIUM-EXTRA50' && upper.indexOf('ELITEGIFT-') !== 0 && upper.indexOf('ELITEADDON50-') !== 0;
      });
      codes.push(code);
      if (!window.EliteCartPromotions) throw new Error('Recarga esta página antes de volver a intentarlo.');
      var cart = await window.EliteCartPromotions.applyCodes(codes);
      var valid = (cart.discount_codes || []).some(function (entry) { return entry.code.toUpperCase() === code.toUpperCase() && entry.applicable; });
      if (choice) {
        var extra = cart.items.find(function (item) { return ownedOffer(item) && item.properties._EliteBundle === transaction; });
        if (!valid || !extra || extra.variant_id !== variantId || extra.quantity !== 1 || extra.final_line_price !== expected) throw new Error('No se pudo aplicar la oferta que elegiste. Inténtalo de nuevo o continúa sin ella.');
      } else {
        if (!valid) throw new Error('No se pudo aplicar tu descuento. Inténtalo de nuevo.');
      }
      buttons.forEach(function (button) { button.disabled = button.dataset.eliteWasDisabled === 'true'; });
      if (trigger) { trigger.disabled = false; trigger.textContent = originalText; }
      busy = false; (clearSelection(),collapseCartGiftChoices());
      if(toCheckout){await openCartGiftCheckout(cartGiftTarget())}else{if (/\/cart\/?$/.test(location.pathname)) window.location.assign(root + 'cart');
      else { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); mountCartGift(); }}
    } catch (error) {
      if (added || removed) await rollback(transaction, previous, removed);
      if (trigger && !form.contains(trigger)) {
        trigger.disabled = false; trigger.textContent = originalText;
        var claimError = trigger.parentElement.querySelector('[data-gift-claim-error]');
        if (!claimError) { claimError = document.createElement('p'); claimError.dataset.giftClaimError = '1'; claimError.setAttribute('role', 'alert'); trigger.after(claimError); }
        claimError.textContent = error.message;
      }
      buttons.forEach(function (button) { button.disabled = button.dataset.eliteWasDisabled === 'true'; });
      busy = false;
      selection();
      message(error.message);
    } finally {
      if (widget) { widget.removeAttribute('aria-busy'); syncGiftCountdown(); }
    }
  }

  async function cleanOrphanGifts() {if(window.__eliteSitewide25Busy)return;
    if (checkoutPending||(busy || cleaning || window.__eliteTitaniumUpgradeBusy)) return;
    cleaning = true;
    try {
      var cart = window.EliteCartPromotions ? await window.EliteCartPromotions.readCart() : await request('cart.js');
      if (checkoutPending||(busy || window.__eliteTitaniumUpgradeBusy)) return;
      var updates = {};
      cart.items.forEach(function (item) {
        if (!ownedOffer(item)) return;
        if (item.properties && item.properties._EliteGift === '1' && item.final_line_price > 0) updates[item.key] = 0;
        if (item.properties && item.properties._EliteAddon === '1') {
          var code = item.properties._EliteAddonCode;
          var valid = code && (cart.discount_codes || []).some(function (entry) { return entry.code.toUpperCase() === code.toUpperCase() && entry.applicable; });
          if (!valid || item.quantity !== 1 || item.final_line_price !== Math.ceil(item.original_price / 2)) updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length) {
        await request('cart/update.js', { updates: updates });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      }
    } catch (error) {} finally { cleaning = false; }
  }

  var activeCartLine = null, offerDocument = null, cartMountJob = null, cartMountAgain = false;
  var offerPages = new Map();
  var cartGiftSpanish = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;
  var cartGiftButton;
  function cartGiftTarget() {
    if (/\/cart\/?$/.test(location.pathname)) return document.querySelector('main .cart-recap');
    return document.querySelector('#mini-cart .mini-cart__recap');
  }
  function placeCartGift() {
    var target = cartGiftTarget();
    if (widget && target && (widget.parentNode !== target.parentNode || widget.nextElementSibling !== target)) target.before(widget);
  }
  async function offerPage(item) {
    var local = document.getElementById('EliteGiftBundleTemplate');
    var localWidget = local && local.content.querySelector('[data-product-id]');
    if (localWidget && Number(localWidget.dataset.productId) === item.product_id) return document;
    if (offerPages.has(item.handle)) return offerPages.get(item.handle);
    var url = new URL(root + 'products/' + encodeURIComponent(item.handle), location.origin);
    var response = await fetch(url.toString(), { credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
    if (!response.ok) return null;
    var page = new DOMParser().parseFromString(await response.text(), 'text/html');
    offerPages.set(item.handle, page);
    return page;
  }
  function destroyCartGift() {
    stopGiftTimer();recoveryFrame = null; recoveryWaiting = false;
    if (widget) widget.remove();
    if (recoveryDialog) recoveryDialog.remove();
    widget = null; selected = null; recoveryDialog = null; recoveryForm = null;
    mode = null; modeKey = ''; giftDeadline = 0; giftInView = false; recoveryProtected = false;
  }
  async function mountCartGift() {if(window.EliteSitewide25&&window.EliteSitewide25.isActive()){activeCartLine=null;destroyCartGift();return;}
    if (checkoutPending||(busy)) return;
    if (cartMountJob) { cartMountAgain = true; return cartMountJob; }
    cartMountJob = (async function () {
      if (!cartGiftTarget()) return;
      var cart = await request('cart.js');if(busy||checkoutPending)return;
      if (cart.items.some(function (item) { return Number(item.product_id) === 15447369810141 && item.quantity > 0; })) { activeCartLine = null; destroyCartGift(); return; }
      var candidates = cart.items.filter(function (item) {
        return !ownedOffer(item) && item.handle !== 'surcharge' && item.original_price > 0 && item.requires_shipping !== false;
      }).sort(function (a, b) { return b.original_price - a.original_price; });
      var chosen = null, page = null;
      for (var index = 0; index < Math.min(candidates.length, 8); index += 1) {
        var candidatePage = await offerPage(candidates[index]);if(busy||checkoutPending)return;
        var template = candidatePage && candidatePage.getElementById('EliteGiftBundleTemplate');
        if (template && template.content.querySelector('[data-gift-choice]')) { chosen = candidates[index]; page = candidatePage; break; }
      }
      if (!chosen) { activeCartLine = null; destroyCartGift(); return; }
      if (widget && activeCartLine && activeCartLine.product_id === chosen.product_id) {
        activeCartLine = chosen; placeCartGift(); syncMode(); return;
      }
      destroyCartGift(); activeCartLine = chosen; offerDocument = page;
      var giftTemplate = page.getElementById('EliteGiftBundleTemplate');
      widget = document.importNode(giftTemplate.content.querySelector('#elite-gift-concepts'), true);
      config = JSON.parse(widget.querySelector('[data-offer-config]').textContent);
      form = document.createElement('form');
      var stylesheet = page.querySelector('link[rel="stylesheet"][href*="elite-free-gift-bundle.css"]');
      if (stylesheet && !document.querySelector('link[href*="elite-free-gift-bundle.css"]')) {
        var href = new URL(stylesheet.getAttribute('href'), location.origin);
        if (href.origin === location.origin) { var link = document.createElement('link'); link.rel = 'stylesheet'; link.href = href.toString(); document.head.appendChild(link); }
      }
      widget.dataset.cartGift = 'true';
      var copyWalker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      while (copyWalker.nextNode()) {
        var textNode = copyWalker.currentNode;
        if (textNode.parentElement && !textNode.parentElement.closest('script,style')) textNode.nodeValue = textNode.nodeValue.replace(/Your 5 minutes start/g, 'Your 1 minute starts').replace(/Tus 5 minutos comienzan/g, 'Tu minuto comienza').replace(/5 more minutes/g, '1 more minute').replace(/5 minutes/g, '1 minute').replace(/5 minutos/g, '1 minuto');
      }
      placeCartGift();
      widget.querySelectorAll('[data-gift-choice]').forEach(updateVariantMedia);
      function claimCartChoice(){(busy||checkoutPending)||(selection(),!(!selected||giftExpired())&&purchase(true,null,null))}
      widget.addEventListener('click', function (event) {
        if (!(event.target instanceof Element)) return;
        var choice = event.target.closest('[data-gift-choice]');
        if (!choice || event.target.closest('select,option,input,button')) return;
        event.preventDefault();
        if (busy || giftExpired()) return;
        var radio = choice.querySelector('input[name="elite_free_gift"]');
        if (radio && !radio.disabled) { radio.checked = true; claimCartChoice(); }
      });
      widget.addEventListener('change', function (event) {
        if (busy || !(event.target instanceof Element)) return;
        if (event.target.matches('[data-gift-variant]')) {
          var choice = event.target.closest('[data-gift-choice]');
          choice.querySelector('input').value = event.target.value; updateChoicePrice(choice); updateVariantMedia(choice);
          choice.querySelector('input[name="elite_free_gift"]').checked = true;
        } else if (!event.target.matches('input[name="elite_free_gift"]')) return;
        claimCartChoice();
      });
      widget.querySelector('[data-close-gifts]').addEventListener('click', function () {
        clearSelection(); widget.querySelector('[data-gift-panel]').hidden = true;
        widget.querySelector('[data-reopen-gifts]').hidden = false; syncGiftCountdown();
      });
      widget.querySelector('[data-reopen-gifts]').addEventListener('click', function () {
        widget.querySelector('[data-gift-panel]').hidden = false; widget.querySelector('[data-reopen-gifts]').hidden = true; syncGiftCountdown();
      });
      mountGiftCountdown(); mountGiftRecovery(); syncMode(); if (cart.items.some(ownedOffer)) collapseCartGiftChoices();
    })().catch(function () { /* Checkout stays available if the optional offer cannot load. */ }).finally(function () {
      cartMountJob = null;
      if (cartMountAgain) { cartMountAgain = false; mountCartGift(); }
    });
    return cartMountJob;
  }
  var cartGiftStyle = document.createElement('style');
  cartGiftStyle.textContent = '#elite-gift-concepts[data-cart-gift]{box-sizing:border-box;width:100%;max-width:100%;margin:12px 0;padding:0 16px}#elite-gift-concepts[data-cart-gift] .eg-heading h2{font-size:20px;line-height:1.2}#elite-gift-concepts[data-cart-gift] .eg-option{max-width:100%;grid-template-columns:20px 64px minmax(0,1fr);min-height:100px;padding:8px;gap:6px}#elite-gift-concepts[data-cart-gift] .eg-picture{grid-column:2;grid-row:1/3;width:64px;height:84px}#elite-gift-concepts[data-cart-gift] .eg-name{font-size:14px}#elite-gift-concepts[data-cart-gift] .eg-desc{font-size:12px}#elite-gift-concepts[data-cart-gift] .eg-price{grid-column:3;flex-direction:row;flex-wrap:wrap;gap:5px}#elite-gift-concepts[data-cart-gift] .eg-price em{font-size:12px}#elite-gift-concepts[data-cart-gift] .eg-countdown{max-width:100%}.elite-cart-gift-apply{display:block;box-sizing:border-box;width:100%;min-height:44px;margin:12px 0 0;padding:12px;border:0;border-radius:8px;background:linear-gradient(135deg,#ee7410,#a93c00);color:#fff;font:700 14px/1.3 inherit;cursor:pointer}.elite-cart-gift-apply:disabled{opacity:.55;cursor:default}#elite-gift-concepts[data-cart-gift] .eg-options{max-height:320px;overflow-y:auto;overscroll-behavior:contain}';
  document.head.appendChild(cartGiftStyle);
  function bootCartGift() { cleanOrphanGifts().then(mountCartGift); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCartGift, { once: true }); else bootCartGift();
  ['cart:updated','cart:change','cart:refresh','cart:rerendered','product:added'].forEach(function (name) {
    document.addEventListener(name, function () { cleanOrphanGifts().then(mountCartGift); });
  });
  var observedCartTarget = null, observedCartSignature = '', cartGiftRefreshTimer = null;
  function watchCartGift() {
    placeCartGift();
    var target = cartGiftTarget();
    if (!target) { observedCartTarget = null; observedCartSignature = ''; return; }
    var scope = target.closest('form') || document.querySelector('main');
    var lines = scope ? Array.from(scope.querySelectorAll('.mini-cart__line-item,.line-item')) : [];
    var signature = lines.map(function (line) {
      var product = line.querySelector('a[href*="/products/"]');
      var quantity = line.querySelector('input[data-current-value],input[name="updates[]"]');
      return (product && product.getAttribute('href') || '') + ':' + (quantity && quantity.value || '1');
    }).join('|');
    if (target === observedCartTarget && signature === observedCartSignature) return;
    observedCartTarget = target; observedCartSignature = signature;
    window.clearTimeout(cartGiftRefreshTimer);
    cartGiftRefreshTimer = window.setTimeout(bootCartGift, 120);
  }
  new MutationObserver(watchCartGift).observe(document.body, { childList: true, subtree: true });
  watchCartGift();
  document.addEventListener('click', function (event) {
    if (event.target instanceof Element && event.target.closest('[data-action="toggle-mini-cart"]')) mountCartGift();
  });

  // A new visit or a closed-to-open drawer transition starts a fresh offer window.
  function restartGiftClock() {
    giftStorageKey = 'elite-gift-deadline:v6-store';
    recoveryUsedKey = 'elite-gift-recovery-used:v2-store';
    recoveryUsed = false;
    saveRecoveryValue(recoveryUsedKey, '0');
    giftDeadline = Date.now() + giftDuration;
    saveGiftDeadline();
    closeGiftRecovery();
    syncGiftCountdown();
  }
  var giftCartWasOpen = false;
  function syncGiftCartOpening() {
    var cart = document.getElementById('mini-cart');
    var open = !!cart && cart.getAttribute('aria-hidden') === 'false';
    if (open && !giftCartWasOpen) restartGiftClock();
    giftCartWasOpen = open;
  }
  new MutationObserver(syncGiftCartOpening).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden']
  });
  window.addEventListener('pageshow', restartGiftClock);
  var giftPageWasHidden = document.hidden;
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && giftPageWasHidden) restartGiftClock();
    giftPageWasHidden = document.hidden;
  });
  restartGiftClock();
  syncGiftCartOpening();
}());
